import projectChair from '../assets/images/projectChair';
import projectFurniture from '../assets/images/projectFurniture';
import projectInterior from '../assets/images/projectInterior';
import projectSpray from '../assets/images/projectSpray';
import projectWall from '../assets/images/projectWall';


export const projectList = [
    {
        projectImg: projectSpray,
        projectName: "Exterior Painting",
        projectLocation: "Dhaka, Bangladesh"
    },
    {
        projectImg: projectInterior,
        projectName: "Interior Painting",
        projectLocation: "Chittagong, Bangladesh"
    },
    {
        projectImg: projectWall,
        projectName: "Wall Painting",
        projectLocation: "Khulna, Bangladesh"
    },
    {
        projectImg: projectFurniture,
        projectName: "Furniture Painting",
        projectLocation: "Dhaka, Bangladesh"
    },
    {
        projectImg: projectChair,
        projectName: "Chair Painting",
        projectLocation: "Sylhet, Bangladesh"
    }
]